var map = {
	"./App": 1648,
	"./App.vue": 1648,
	"./accessiblity": 2530,
	"./accessiblity.js": 2530,
	"./analytics/supabaseClient": 6743,
	"./analytics/supabaseClient.js": 6743,
	"./analytics/tracker": 9816,
	"./analytics/tracker.js": 9816,
	"./assets/chevron-select.svg": 6968,
	"./assets/customers/Amazon.svg": 4056,
	"./assets/customers/AmazonLearn.svg": 698,
	"./assets/design-tokens.css": 3895,
	"./assets/fonts/museo-moderno/MuseoModerno-Regular.ttf": 4323,
	"./assets/fonts/museo-moderno/MuseoModerno-Regular.woff": 353,
	"./assets/fonts/open-sans/OpenSans-Regular.ttf": 4567,
	"./assets/fonts/open-sans/OpenSans-Regular.woff": 8725,
	"./assets/fonts/switzer/Switzer-Variable.woff": 2116,
	"./assets/fonts/switzer/Switzer-Variable.woff2": 2622,
	"./assets/home_lg.png": 5909,
	"./assets/icons": 1921,
	"./assets/icons.json": 1921,
	"./assets/icons/icon_code.svg": 4240,
	"./assets/icons/icon_design_systems.svg": 5302,
	"./assets/icons/icon_product_design.svg": 1085,
	"./assets/icons/icon_product_stratetgy.svg": 5112,
	"./assets/icons/icon_prototype.svg": 8983,
	"./assets/icons/icon_terminal_code.svg": 2265,
	"./assets/icons/icon_user_experience.svg": 1049,
	"./assets/icons/icon_user_interface.svg": 7526,
	"./assets/img-placeholder.jpg": 1895,
	"./assets/tailwind.css": 200,
	"./assets/transitions.css": 9234,
	"./assets/utils.css": 6681,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_mermaid-chart.png": 9047,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_process_graphic_banner.svg": 5630,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_prototype_thumbnail.png": 8154,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_sarah_cheng_persona_profile.png": 7473,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_00.png": 6541,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_01.png": 4036,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_02.png": 3951,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_combined_01.png": 5244,
	"./assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_combined_02.png": 5303,
	"./assets/work-gallery/CS-TA/CS_TA_analysis_old_UI_00.png": 57,
	"./assets/work-gallery/CS-TA/CS_TA_analysis_old_UI_01.png": 3808,
	"./assets/work-gallery/CS-TA/CS_TA_audit.png": 2144,
	"./assets/work-gallery/CS-TA/CS_TA_early_iterations_00.png": 5782,
	"./assets/work-gallery/CS-TA/CS_TA_early_iterations_01.png": 3231,
	"./assets/work-gallery/CS-TA/CS_TA_event-details.png": 2932,
	"./assets/work-gallery/CS-TA/CS_TA_event-providers.png": 1452,
	"./assets/work-gallery/CS-TA/CS_TA_event-status.png": 5638,
	"./assets/work-gallery/CS-TA/CS_TA_exploration.gif": 9333,
	"./assets/work-gallery/CS-TA/CS_TA_feedback_loop.png": 2887,
	"./assets/work-gallery/CS-TA/CS_TA_finalexp_block00.png": 9714,
	"./assets/work-gallery/CS-TA/CS_TA_finalexp_block01.png": 843,
	"./assets/work-gallery/CS-TA/CS_TA_hero-screen.png": 5260,
	"./assets/work-gallery/CS-TA/CS_TA_reportpage.png": 8478,
	"./assets/work-gallery/CS-TA/CS_talent_alchemy_chart.png": 3454,
	"./assets/work-gallery/CS-design-strategy/Amazon_Logo_SquidInk_RGB.png": 5700,
	"./assets/work-gallery/CS-design-strategy/CS_Hero-composition-01.png": 6047,
	"./assets/work-gallery/CS-design-strategy/CS_Hero-composition-02.png": 2484,
	"./assets/work-gallery/CS-design-strategy/CS_Hero-composition-03.png": 4989,
	"./assets/work-gallery/CS-design-strategy/CS_hero_strategic_design.png": 4352,
	"./assets/work-gallery/CS-design-strategy/CS_icon_cube.svg": 4127,
	"./assets/work-gallery/CS-design-strategy/CS_icon_eye-lash.svg": 316,
	"./assets/work-gallery/CS-design-strategy/CS_icon_shapes.svg": 4638,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-adding-trainings.mp4": 4937,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-docs-thumbnail.png": 3678,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-exploring-trainings.mp4": 164,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-exploring-trainings_expanded.png": 1250,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-exploring-trainings_home.png": 1952,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-learner-dashboard.png": 4126,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-learner-view.mp4": 1899,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-manager-dashboard.png": 2220,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-many-strategies.mp4": 1519,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-train-persona_frontline.png": 813,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-train-persona_leader.png": 8791,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-training-page-skills.png": 7541,
	"./assets/work-gallery/CS-design-strategy/CS_strategy-training-page.png": 8332,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_approach_01.png": 6426,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_approach_02.png": 5409,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_exploring-options_00.png": 7578,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_exploring-options_01.png": 6435,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_panel_00.png": 2483,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_panel_01.png": 7274,
	"./assets/work-gallery/CS-design-strategy/CS_strategy_panel_02.png": 7857,
	"./assets/work-gallery/CS-design-strategy/Hero-screen.png": 6174,
	"./assets/work-gallery/CS-design-strategy/floating_courses.png": 5578,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-ORCA-approach.png": 5002,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-ORCA-approach_mobile.png": 9577,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-conversation.png": 6816,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-dashboard.png": 85,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-huddle.png": 7393,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-joining-huddle.png": 3664,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-settings.png": 9262,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-translate.png": 3547,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-desktop-translate_02.png": 9998,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-handover-dev-notations-00.png": 2208,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-handover-dev-notations-01.png": 7033,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-handover-dev-notations-02.png": 1890,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-handover-dev-notations-03.png": 891,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-legacy-experience.png": 7468,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-solution_00.png": 8317,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-solution_01.png": 6259,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-solution_02.png": 648,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-solution_03.png": 1777,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-user-research.png": 7343,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-user-wireframe-00.png": 3995,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-user-wireframe-01.png": 338,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-user-wireframe-02.png": 4345,
	"./assets/work-gallery/CS-say-hi/CS-sayhi-user-wireframe-03.png": 8592,
	"./assets/work-gallery/CS-say-hi/CS_early-iterations.png": 705,
	"./assets/work-gallery/CS-say-hi/CS_finalexp_block00.png": 1284,
	"./assets/work-gallery/CS-say-hi/CS_finalexp_block01.png": 2413,
	"./assets/work-gallery/CS-say-hi/CS_finalexp_main.png": 3240,
	"./assets/work-gallery/CS-say-hi/CS_huddle-diagram.png": 3143,
	"./assets/work-gallery/CS-say-hi/CS_icon_coreFeature_ASR.svg": 3013,
	"./assets/work-gallery/CS-say-hi/CS_icon_coreFeature_TTS.svg": 6336,
	"./assets/work-gallery/CS-say-hi/CS_icon_coreFeature_TXT.svg": 8259,
	"./assets/work-gallery/CS-say-hi/CS_icon_coreFeature_VTT.svg": 781,
	"./assets/work-gallery/CS-say-hi/CS_sayhi-problem-statement.png": 1,
	"./assets/work-gallery/CS-say-hi/CS_truck-image.png": 3162,
	"./assets/work-gallery/CS-say-hi/CS_validation-prototype.png": 7295,
	"./assets/work-gallery/CS-say-hi/sayhi-cover_new.png": 4455,
	"./assets/work-gallery/CS-say-hi/sayhi-hero-graphic.png": 1578,
	"./assets/work-gallery/CS-say-hi/sayhi-hero-graphic_darkmode.png": 5594,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_00.png": 4232,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_01.png": 6273,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_02.png": 6378,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_03.png": 6211,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_04.png": 6812,
	"./assets/work-gallery/CS-xweather/CS_xweather-colour_05.png": 8437,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-cloud.svg": 5072,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-moon.svg": 1614,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-rain.svg": 1307,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-snow.svg": 6144,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-sun.svg": 4585,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-thunder.svg": 5993,
	"./assets/work-gallery/CS-xweather/CS_xweather-icon-wind.svg": 743,
	"./assets/work-gallery/CS-xweather/CS_xweather-logo-design.png": 6611,
	"./assets/work-gallery/CS-xweather/CS_xweather-results.png": 5665,
	"./assets/work-gallery/CS-xweather/xweather-cover.png": 4707,
	"./assets/work-gallery/icons/CS_calendar_time.svg": 7091,
	"./assets/work-gallery/icons/CS_icon_proposal.svg": 6821,
	"./assets/work-gallery/icons/CS_icon_results.svg": 311,
	"./assets/work-gallery/logos/TA_logo_ink.png": 2078,
	"./assets/work-gallery/logos/TA_logo_white.png": 8937,
	"./assets/work-gallery/logos/amazon_logo.png": 9436,
	"./assets/work-gallery/logos/sayhi_logo.png": 6854,
	"./assets/work-gallery/logos/xweather_logo.png": 3584,
	"./assets/work-gallery/thumbnails/card-image.png": 3355,
	"./assets/work-gallery/thumbnails/thumbnail_Xweather_transparent.png": 3445,
	"./assets/work-gallery/thumbnails/thumbnail_amazonlearn_transparent.png": 9929,
	"./assets/work-gallery/thumbnails/thumbnail_sayhi_transparent.png": 5047,
	"./assets/work-gallery/thumbnails/thumbnail_talentAlchemy_transparent.png": 1372,
	"./components/LazyVideo": 726,
	"./components/LazyVideo.vue": 726,
	"./components/cardProject": 3180,
	"./components/cardProject.vue": 3180,
	"./components/clientsSection": 3856,
	"./components/clientsSection.vue": 3856,
	"./components/expanderStep": 2089,
	"./components/expanderStep.vue": 2089,
	"./components/footer": 787,
	"./components/footer.vue": 787,
	"./components/iconDisplay": 8329,
	"./components/iconDisplay.vue": 8329,
	"./components/imageLauncher": 8094,
	"./components/imageLauncher.vue": 8094,
	"./components/linkedinButton": 9809,
	"./components/linkedinButton.vue": 9809,
	"./components/logos/AmazonLogo": 389,
	"./components/logos/AmazonLogo.vue": 389,
	"./components/logos/BarclaysLogo": 3674,
	"./components/logos/BarclaysLogo.vue": 3674,
	"./components/logos/DeutscheLogo": 3154,
	"./components/logos/DeutscheLogo.vue": 3154,
	"./components/logos/HsbcLogo": 7598,
	"./components/logos/HsbcLogo.vue": 7598,
	"./components/logos/RbcLogo": 5268,
	"./components/logos/RbcLogo.vue": 5268,
	"./components/mainContent": 8142,
	"./components/mainContent.vue": 8142,
	"./components/navBar": 1568,
	"./components/navBar.vue": 1568,
	"./components/navLinks": 9866,
	"./components/navLinks.vue": 9866,
	"./components/projectList": 4703,
	"./components/projectList.vue": 4703,
	"./components/resumeButton": 8940,
	"./components/resumeButton.vue": 8940,
	"./components/routerRender": 2283,
	"./components/routerRender.vue": 2283,
	"./components/themeSwitcher": 3229,
	"./components/themeSwitcher.vue": 3229,
	"./composables/useScrollReveal": 6673,
	"./composables/useScrollReveal.js": 6673,
	"./content/404": 7197,
	"./content/404.json": 7197,
	"./content/contact": 4041,
	"./content/contact.json": 4041,
	"./content/projectList": 7256,
	"./content/projectList.json": 7256,
	"./content/works": 7412,
	"./content/works.json": 7412,
	"./data/skillTags": 2884,
	"./data/skillTags.js": 2884,
	"./encoder": 5863,
	"./encoder.js": 5863,
	"./i18n": 8992,
	"./i18n.js": 8992,
	"./main": 7582,
	"./main.js": 7582,
	"./router": 7325,
	"./router/": 7325,
	"./router/index": 7325,
	"./router/index.js": 7325,
	"./translations/en": 2770,
	"./translations/en.json": 2770,
	"./translations/es": 8302,
	"./translations/es.json": 8302,
	"./views/About": 7492,
	"./views/About.vue": 7492,
	"./views/CS_AIUX_process": 4916,
	"./views/CS_AIUX_process.vue": 4916,
	"./views/CS_TA": 93,
	"./views/CS_TA.vue": 93,
	"./views/CS_sayhi": 3639,
	"./views/CS_sayhi.vue": 3639,
	"./views/CS_strategic_design": 3224,
	"./views/CS_strategic_design.vue": 3224,
	"./views/CS_xweather": 5826,
	"./views/CS_xweather.vue": 5826,
	"./views/Contact": 7630,
	"./views/Contact.vue": 7630,
	"./views/Home": 2159,
	"./views/Home.vue": 2159,
	"./views/Login": 4098,
	"./views/Login.vue": 4098,
	"./views/NotFound": 7833,
	"./views/NotFound.vue": 7833,
	"./views/Stats": 5464,
	"./views/Stats.vue": 5464,
	"./views/bk_CS_sayhi copy": 9061,
	"./views/bk_CS_sayhi copy.vue": 9061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;